// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-dashboard-container {
  width: 100%;
  height: calc(100% - 5rem);
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashboard-container {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: flex-start;
  /* width:100vw; */
  width: 100%;
  height: 100%;
  /* gap: 2rem; */
  background-color: rgb(250, 251, 252);;
}
.dashboard-container.images{
  padding:1rem;
  flex-direction: column;
  position:relative;
}
.table-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* background-color: rgb(248, 250, 255); */
  height:100%;
}
.table-container-in {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: space-between; */
  background-color: white;
  border: 1px solid rgb(231, 236, 242);
  border-top:0;
  /* padding:0.5rem; */
  border-collapse: collapse;
  border-image-slice: 1;
  height:calc(100vh - 4rem - 4.25rem);
  /* overflow-y: scroll; */
  position: relative;
  /* border: double 1px transparent; */
  /* border-top-right-radius: 0.5rem; */
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  /* background-image: linear-gradient(white, white), 
                  linear-gradient(to right, rgb(101, 197, 196), rgb(218, 226, 255));
background-origin: border-box;
background-clip: content-box, border-box; */
}
.bay-buttons-container.images{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgb(236, 242, 253);
  /* gap: 1rem; */
  padding:1rem;
  z-index: 5;
  border-top:1px solid rgb(224, 230, 238);
  border-bottom:1px solid rgb(224, 230, 238);
  border-right:1px solid rgb(224, 230, 238);
  border-left:1px solid rgb(224, 230, 238);
  height:-moz-fit-content;
  height:fit-content;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  position:relative;
}
.reportpage-right-container{
  flex: 1 1;
  width: 100%;
  max-width:100%;
  max-height: 100vh; /* Set a maximum height */
  overflow:none
  
}
.mainCss-report{
  width: 85%;
  height:100vh;
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.page-container{
  width:100vw;
  height:100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.calender-button-in-image-container.images{
  width:-moz-fit-content;
  width:fit-content;
  padding:4px;
  display: flex;
  align-items: center;
  justify-content: center;
  height:100%;
  background-color: rgb(211, 185, 49);
}
.calender-button.images.popup{
  width:100%;
  display: flex;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/pages/folders/Folders.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oCAAoC;EACpC,uBAAuB;EACvB,oCAAoC;EACpC,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,mCAAmC;EACnC,wBAAwB;EACxB,kBAAkB;EAClB,oCAAoC;EACpC,qCAAqC;EACrC,iCAAiC;EACjC,kCAAkC;EAClC;;;2CAGyC;AAC3C;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,UAAU;EACV,uCAAuC;EACvC,0CAA0C;EAC1C,yCAAyC;EACzC,wCAAwC;EACxC,uBAAkB;EAAlB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,SAAO;EACP,WAAW;EACX,cAAc;EACd,iBAAiB,EAAE,yBAAyB;EAC5C;;AAEF;AACA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,sBAAiB;EAAjB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mCAAmC;AACrC;AACA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC","sourcesContent":[".report-dashboard-container {\r\n  width: 100%;\r\n  height: calc(100% - 5rem);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.dashboard-container {\r\n  display: flex;\r\n  /* flex-direction: column; */\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  /* width:100vw; */\r\n  width: 100%;\r\n  height: 100%;\r\n  /* gap: 2rem; */\r\n  background-color: rgb(250, 251, 252);;\r\n}\r\n.dashboard-container.images{\r\n  padding:1rem;\r\n  flex-direction: column;\r\n  position:relative;\r\n}\r\n.table-container {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  /* background-color: rgb(248, 250, 255); */\r\n  height:100%;\r\n}\r\n.table-container-in {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  /* justify-content: space-between; */\r\n  background-color: white;\r\n  border: 1px solid rgb(231, 236, 242);\r\n  border-top:0;\r\n  /* padding:0.5rem; */\r\n  border-collapse: collapse;\r\n  border-image-slice: 1;\r\n  height:calc(100vh - 4rem - 4.25rem);\r\n  /* overflow-y: scroll; */\r\n  position: relative;\r\n  /* border: double 1px transparent; */\r\n  /* border-top-right-radius: 0.5rem; */\r\n  border-bottom-left-radius: 0.5rem;\r\n  border-bottom-right-radius: 0.5rem;\r\n  /* background-image: linear-gradient(white, white), \r\n                  linear-gradient(to right, rgb(101, 197, 196), rgb(218, 226, 255));\r\nbackground-origin: border-box;\r\nbackground-clip: content-box, border-box; */\r\n}\r\n.bay-buttons-container.images{\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background-color: rgb(236, 242, 253);\r\n  /* gap: 1rem; */\r\n  padding:1rem;\r\n  z-index: 5;\r\n  border-top:1px solid rgb(224, 230, 238);\r\n  border-bottom:1px solid rgb(224, 230, 238);\r\n  border-right:1px solid rgb(224, 230, 238);\r\n  border-left:1px solid rgb(224, 230, 238);\r\n  height:fit-content;\r\n  border-top-left-radius: 4px;\r\n  border-top-right-radius: 4px;\r\n  position:relative;\r\n}\r\n.reportpage-right-container{\r\n  flex: 1;\r\n  width: 100%;\r\n  max-width:100%;\r\n  max-height: 100vh; /* Set a maximum height */\r\n  overflow:none\r\n  \r\n}\r\n.mainCss-report{\r\n  width: 85%;\r\n  height:100vh;\r\n  display:flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.page-container{\r\n  width:100vw;\r\n  height:100vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n}\r\n.calender-button-in-image-container.images{\r\n  width:fit-content;\r\n  padding:4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height:100%;\r\n  background-color: rgb(211, 185, 49);\r\n}\r\n.calender-button.images.popup{\r\n  width:100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
